<template>
  <div>
    <div>{{ label }}</div>
    <div class="break-words font-bold"><slot></slot></div>
  </div>
</template>
<script setup lang="ts">
type ArendePropertyPropsType = {
  label: string;
};
defineProps<ArendePropertyPropsType>();
</script>
